(function () {

  'use strict';

  function pxOneloginForm(IdpProviderService, toastr, $filter) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/authenticationSettings/oneLogin/oneLoginForm/oneLoginForm.template.html',
      link: function (scope) {
        scope.descriptor = IdpProviderService.descriptorByType('onelogin');

        scope.idProvider = {
          domain: null,
          client_id: null,
          client_secret: null
        };

        scope.idProviderInvalid = true;

        scope.testForm = function () {
          const required = {
            domain: !!scope.idProvider.domain,
            client_id: !!scope.idProvider.client_id,
            client_secret: !!scope.idProvider.client_secret
          };

          const requirementsFulfilled = Object.values(required).every(function (value) {
            return value === true;
          });

          scope.idProviderInvalid = !requirementsFulfilled;
        };

        scope.submit = function () {
          IdpProviderService.create(scope.tenant, 'onelogin', scope.idProvider).then(function () {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function (error) {
            IdpProviderService.handleCreateError(error, scope.descriptor, scope.tenant);
          });
          scope.callback();
        };
      }
    };
  }

  pxOneloginForm.$inject = ['IdpProviderService', 'toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxOneloginForm', pxOneloginForm);

})();
